import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Activity, CreditCard, Repeat } from 'lucide-react';

const B = process.env.REACT_APP_BACKEND_URL;
const ago = (ts) => {
  const s = Math.max(0, Math.floor(Date.now() / 1000 - ts));
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export const RecentPurchases = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    const load = () => axios.get(`${B}/api/public/recent-purchases`).then(r => setRows(r.data.purchases)).catch(() => setRows([]));
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="w-full max-w-md bg-slate-900/70 border border-slate-800 rounded-2xl p-5" data-testid="recent-purchases">
      <p className="text-sm text-white font-semibold flex items-center gap-2 mb-3"><Activity className="w-4 h-4 text-emerald-400 animate-pulse" /> Recent purchases</p>
      {rows === null && <p className="text-xs text-slate-500">Loading live trades…</p>}
      {rows && !rows.length && <p className="text-xs text-slate-500">No purchases yet. Be the first.</p>}
      <div className="space-y-2 max-h-56 overflow-y-auto">
        {(rows || []).map((r, i) => (
          <a key={i} href={r.url || '#'} target="_blank" rel="noreferrer" className="flex items-center justify-between text-xs py-1.5 border-b border-slate-800 hover:bg-slate-800/50 transition-colors" data-testid={`recent-purchase-${i}`}>
            <span className="flex items-center gap-2 text-slate-300">{r.source === 'card' ? <CreditCard className="w-3 h-3 text-cyan-400" /> : <Repeat className="w-3 h-3 text-amber-400" />}{r.buyer}</span>
            <span className="text-emerald-300 font-mono">+{Number(r.beth).toLocaleString(undefined, { maximumFractionDigits: 2 })} BETH</span>
            <span className="text-slate-500 w-16 text-right">{ago(r.at)}</span>
          </a>
        ))}
      </div>
    </div>
  );
};
